import { FormControl } from '@angular/forms';

const BREB_KEY_FORMATS: RegExp[] = [
  /^@[A-Za-z0-9]{5,20}$/,         // alias ("llave")
  /^[^@\s]{1,30}@[^@\s]{1,61}$/,  // email
  /^(\+?57)?3\d{9}$/,             // CO mobile number (optional +57/57 country code)
  /^\d{6,11}$/,                   // citizen ID (PPT, CC, NIT, TI)
  /^[A-Za-z0-9]{4,20}$/,          // CE / passport
];

export class BreBValidator {

  /**
   * Mirrors Cobre's VL1 "valid Bre-B account format" rule: a key is valid when it
   * matches ANY supported format. Returns a single union error on purpose — it does
   * not report which format the user was attempting.
   */
  static checkBreBError(control: FormControl): { breBFormatError: boolean } | undefined {
    if (!control.value) return;
    const key = String(control.value).trim();
    if (BREB_KEY_FORMATS.some(format => format.test(key))) return;
    return { breBFormatError: true };
  }
}



// WEBPACK FOOTER //
// ./src/validators/breBValidator.ts